import React from 'react';
import { LucideIcon } from 'lucide-react';
import { Card } from '../common/Card';

interface StatsCardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  change?: {
    value: number;
    type: 'increase' | 'decrease';
  };
  color?: string;
}

export const StatsCard: React.FC<StatsCardProps> = ({
  title,
  value,
  icon: Icon,
  change,
  color = 'gold'
}) => {
  const colorClasses = {
    gold: 'text-gold-400 bg-gold-500/10',
    green: 'text-green-400 bg-green-500/10',
    blue: 'text-blue-400 bg-blue-500/10',
    purple: 'text-purple-400 bg-purple-500/10'
  };
  
  return (
    <Card className="relative overflow-hidden" hover>
      <div className="flex items-center">
        <div className={`p-3 rounded-lg ${colorClasses[color as keyof typeof colorClasses]}`}>
          <Icon className="w-6 h-6" />
        </div>
        <div className="ml-4 flex-1">
          <p className="text-sm font-medium text-gray-400">{title}</p>
          <p className="text-2xl font-bold text-white mt-1">{value}</p>
          {change && (
            <p className={`text-sm mt-1 ${
              change.type === 'increase' ? 'text-green-400' : 'text-red-400'
            }`}>
              {change.type === 'increase' ? '+' : '-'}{Math.abs(change.value)}%
              <span className="text-gray-400 ml-1">vs last month</span>
            </p>
          )}
        </div>
      </div>
      
      {/* Gradient overlay */}
      <div className={`
        absolute top-0 right-0 w-24 h-full opacity-10
        bg-gradient-to-l from-${color}-500 to-transparent
      `} />
    </Card>
  );
};